import React, { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { Typography } from "@platform/design-system";

import { AnalystsTab } from "./components/AnalystsTab";
import { TeamsTab } from "./components/TeamsTab";

export const AnalystsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box p={3} pt={12}>
      <Typography variant="header-large" component="h1" mb={3}>
        Analysts & Teams
      </Typography>

      <Tabs
        value={activeTab}
        onChange={(_, newValue: number) => setActiveTab(newValue)}
        aria-label="Analysts and Teams management tabs"
        sx={{ mb: 3 }}
      >
        <Tab
          label="Analysts"
          id="tab-analysts"
          aria-controls="tabpanel-analysts"
        />
        <Tab label="Teams" id="tab-teams" aria-controls="tabpanel-teams" />
      </Tabs>

      <div
        role="tabpanel"
        id="tabpanel-analysts"
        aria-labelledby="tab-analysts"
        hidden={activeTab !== 0}
      >
        {activeTab === 0 && <AnalystsTab />}
      </div>
      <div
        role="tabpanel"
        id="tabpanel-teams"
        aria-labelledby="tab-teams"
        hidden={activeTab !== 1}
      >
        {activeTab === 1 && <TeamsTab />}
      </div>
    </Box>
  );
};
